import { useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import { getAllClientes } from '../../../Services/clienteService'

const useClientesModalVenta = () => {
    const isMountedRef = useRef(true)
    const [clientes, setClientes] = useState([])
    const [isLoad, setIsLoad] = useState(true)

    // pagination
    const [page, setPage] = useState(0)
    const [totalRegister, setTotalRegister] = useState(0)
    const [totalPage, setTotalPage] = useState(0)
    const [query, setQuery] = useState('')

    useEffect(() => {
        if (isLoad) {
            getAllClientes(true, 0, query)
                .then((res) => {
                    if (isMountedRef.current) {
                        setClientes(res.data.content)
                        setTotalRegister(res.data.totalElements)
                        setTotalPage(res.data.totalPages)
                        setIsLoad(false)
                    }
                })
                .catch((err) => { if (isMountedRef.current) { console.log('error') } })
            setIsLoad(false)
        } else {
            setIsLoad(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoad])

    useEffect(() => {
        return () => {
            isMountedRef.current = false
        }
    }, [])



    const nextPage = () => {
        if (totalPage === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        if (page === totalPage - 1) {
            Swal.fire({
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }

        getAllClientes(true, page + 1, query)
            .then((res) => {
                if (isMountedRef.current) {
                    setPage(page + 1)
                    setClientes(res.data.content)
                    setTotalRegister(res.data.totalElements)
                    setTotalPage(res.data.totalPages)
                    setIsLoad(false)
                }
            })
            .catch((err) => { if (isMountedRef.current) { console.log('error') } })
    }

    const previousPage = () => {
        if (page === 0) {
            Swal.fire({
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }

        getAllClientes(true, page - 1, query)
            .then((res) => {
                if (isMountedRef.current) {
                    setPage(page - 1)
                    setClientes(res.data.content)
                    setTotalRegister(res.data.totalElements)
                    setTotalPage(res.data.totalPages)
                    setIsLoad(false)
                }
            })
            .catch((err) => { if (isMountedRef.current) { console.log('error') } })
    }

    const handleBuscador = (e) => {
        setQuery(e.target.value)
        if (e.key === 'Enter') {
            // verificar si la query isEmpty hacer otra consulta
            getAllClientes(true, page + 1, e.target.value)
                .then((res) => {
                    if (isMountedRef.current) {
                        setPage(0)
                        setClientes(res.data.content)
                        setTotalRegister(res.data.totalElements)
                        setTotalPage(res.data.totalPages)
                        setIsLoad(false)
                    }
                })
                .catch((err) => { if (isMountedRef.current) { console.log('error') } })
        }
    }
    return {
        handleBuscador,
        clientes,
        previousPage,
        nextPage,
        totalRegister,
        totalPage,
        page,
    }
}

export default useClientesModalVenta